import React, { useEffect, useState } from 'react';
import { getReportPhieuCoc, saveLogUser } from '../../services/apis';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, theme } from 'antd';
import dayjs from 'dayjs';
import LoadingBase from '../../components/LoadingBase';
import { formatNumber } from '../../utils/funcHelper';
import FooterTable from '../../components/FooterTable';
import "../../css/listbook-page.css";
import { useSelector } from 'react-redux';

const ReportBCDatCocPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const { RangePicker } = DatePicker;
    const userReducer = useSelector(state => state?.userReducer);

    const columns = [
        {
            title: 'Lái xe',
            dataIndex: 'tenlaixe',
            key: 'name',
            render: (text, record, index) => (<a>{text}</a>)
        },
        {
            title: 'CMND',
            dataIndex: 'cmnd',
            align: 'center',
        },
        {
            title: 'BSX',
            dataIndex: 'bsx',
            align: 'center',
        },
        {
            title: 'Số phiếu cọc',
            dataIndex: 'maphieucan',
            align: 'center',
        },
        {
            title: 'Số phiếu trả',
            dataIndex: 'maphieucan_tracoc',
            align: 'center',
        },
        {
            title: 'Người thu cọc',
            dataIndex: 'create_username',
            align: 'center',
        },
        {
            title: 'Người trả cọc',
            dataIndex: 'update_username',
            align: 'center',
        },
        {
            title: 'Số tiền',
            dataIndex: 'sotien',
            align: 'center',
            render: (text, record, index) => (<div className='format-number-table'>{formatNumber(parseInt(text), 0)}</div>)
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            align: 'center',
            render: (text, record, index) => (<div style={text === "2" ? {color: 'blue'} : {color: 'red'}}>{text === "1" ? "Đã thu cọc" : (text === "2" ? "Đã trả cọc" : "Đã huỷ")}</div>)
        },
        {
            title: 'Ngày',
            dataIndex: 'createtime',
            align: 'center',
            render: (text, record, index) => (<div>{dayjs(text).format("DD/MM/YYYY")}</div>)
        }

    ];
    const optionStatus = [
        {
            value: 1,
            label: "Đã thu cọc"
        },
        {
            value: 2,
            label: "Đã trả cọc"
        }
        ,
        {
            value: 3,
            label: "Đã huỷ"
        }
    ]
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10
    };
    const getDataReport = async (currentPage) => {
        const params = {
            fromDate: dayjs(form.getFieldValue("date")?.[0]).format("DD/MM/YYYY") ?? null,
            toDate: dayjs(form.getFieldValue("date")?.[1]).format("DD/MM/YYYY") ?? null,
            status: form.getFieldValue("status") ?? null,
            keyword: form.getFieldValue("keyword") ?? null,
            limit: 50,
            currentPage: currentPage
        }
        setLoading(true);
        const res = await getReportPhieuCoc(params);
        setLoading(false);
        if (res && res?.status === "success" && res?.data) {
            setData([...res?.data]);
            setTotalPage(res?.totalPages ?? 0);
        } else {
            setData([]);
            setTotalPage(0);
        }
    }
    const handleNext = () => {
        if (loading) {
            return;
        }
        const page = currentPage;
        setCurrentPage(page + 1);
        getDataReport(page + 1);
    }
    const handlePrev = () => {
        if (loading) {
            return;
        }
        const page = currentPage;
        setCurrentPage(page - 1);
        getDataReport(page - 1);
    }
    const handleOnSelect = (value) => {
        setCurrentPage(value);
        getDataReport(value)
    }
    const saveLog = async (action) => {
        const params = {
            action: action,
            username: userReducer?.data?.username,
            description: 'Click bao cao'
        };
        const res = await saveLogUser(params);
    }
    const onFinish = (data) => {
        setCurrentPage(1);
        getDataReport(1);
        saveLog("Lọc báo cáo Đặt cọc");
    }
    
    useEffect(() => {
        form.setFieldsValue({
            date: [dayjs().startOf('month'), dayjs()]
        })
        getDataReport(1);
    }, [])

    return (
        <div className='container-content'>
            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'keyword'}
                        >
                            <Input placeholder={'Tên lái xe/CMND'} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name={'date'}
                        >
                            <RangePicker
                                style={{ height: 40, width: '100%' }}
                                placeholder={['Bắt đầu', 'Kết thúc']}
                                format={"DD/MM/YYYY"}
                                allowClear={false}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name={'status'}
                        >
                            <Select
                                placeholder="Chọn trạng thái"
                                allowClear 
                                options={optionStatus}
                                style={{height: 40}}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit">
                                Tìm kiếm
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table 
                className='table-book'
                dataSource={data}
                columns={columns}
                pagination={false}
                rowKey={(record) => record?.id}
                style={{minHeight: 'calc(100vh - 220px)'}}
            />
            <FooterTable
                totalRecord={data?.length}
                totalPage={totalPage}
                currentPage={currentPage}
                handleNext={handleNext}
                handlePrev={handlePrev}
                onSelect={handleOnSelect}
            >
                <Col span={5}>
                    <span className="txt-title-footer">Tiền cọc còn lại: {formatNumber(data?.filter(item => item?.status === "1").reduce((totalMoney, currentValue) => totalMoney + parseInt(currentValue.sotien), 0), 0)}đ</span>
                </Col>
                <Col span={5}>
                    <span className="txt-title-footer">Tiền cọc đã trả: {formatNumber(data?.filter(item => item?.status === "2").reduce((totalMoney, currentValue) => totalMoney + parseInt(currentValue.sotien), 0), 0)}đ</span>
                </Col>
            </FooterTable>
            <LoadingBase loading={loading}/>
        </div>
    );
};
export default ReportBCDatCocPage;